/* 🧠 REDUX */
import { useSelector } from "react-redux/es/hooks/useSelector";

/* 🎨 STYLES */
import { Container, ProfileImage, Name } from "./styles";

/* 🔧 UTILS */
import { isValidaProp } from "../../../../util/validate";

const ImageProfile = (props) => {
    const Image = isValidaProp(props.Image) ? props.Image : require("../../../../Assets/Images/profile.png")
    const username = isValidaProp(props.username) ? props.username : '';
    const menuVisibility = useSelector(state => state.MenuReducer.visibility);

    return(
        <Container onClick={(e)=>{e.preventDefault(); props.function()}} href={props.page} $select={props.select}>
            <ProfileImage src={Image}/>
            {menuVisibility && <Name>{username}</Name>}
        </Container>
    )
}

export default ImageProfile;